import { render, staticRenderFns } from "./intelSort.vue?vue&type=template&id=178b3c8d&scoped=true"
import script from "./intelSort.vue?vue&type=script&lang=js"
export * from "./intelSort.vue?vue&type=script&lang=js"
import style0 from "./intelSort.vue?vue&type=style&index=0&id=178b3c8d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178b3c8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('178b3c8d')) {
      api.createRecord('178b3c8d', component.options)
    } else {
      api.reload('178b3c8d', component.options)
    }
    module.hot.accept("./intelSort.vue?vue&type=template&id=178b3c8d&scoped=true", function () {
      api.rerender('178b3c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wigects/intelSort.vue"
export default component.exports